import { Controller } from "@hotwired/stimulus";
import { connectStorageScope } from "../base_path";

// Forced-registration gate (SUR-1871). A soft, client-side conversion nudge:
// once a visitor has viewed `threshold` Connect pages for this agent without
// registering, reveal a registration overlay. Counting lives in localStorage
// (keyed per host so each agent counts separately) so the server response stays
// publicly CDN-cacheable — the server only emits this markup when the visitor
// is NOT already registered (Connect::PublicSession#registration_gate_active?).
//
// After a successful registration the confirm flow lands on ?registered=1,
// which sets a durable "registered" flag (here and in connect.js, which runs on
// every page even when no gate markup is present) so the gate never fires again
// on this device — even after the 24h server session lapses.
export default class extends Controller {
  static targets = ["overlay"];
  static values = { threshold: { type: Number, default: 0 } };

  connect() {
    try {
      const store = window.localStorage;

      if (this.justRegistered()) {
        store.setItem(this.registeredKey(), "1");
        store.removeItem(this.viewsKey());
        return;
      }
      if (store.getItem(this.registeredKey()) === "1") return;

      const views = (parseInt(store.getItem(this.viewsKey()), 10) || 0) + 1;
      store.setItem(this.viewsKey(), String(views));

      if (this.thresholdValue > 0 && views >= this.thresholdValue) this.reveal();
    } catch (_e) {
      // localStorage unavailable (private mode / blocked) — never block the page.
    }
  }

  justRegistered() {
    return new URLSearchParams(window.location.search).get("registered") === "1";
  }

  reveal() {
    if (!this.hasOverlayTarget) return;
    this.overlayTarget.hidden = false;
    document.body.style.overflow = "hidden"; // lock scroll behind the overlay
  }

  viewsKey() {
    return `ssc_reg:${connectStorageScope()}:views`;
  }

  registeredKey() {
    return `ssc_reg:${connectStorageScope()}:registered`;
  }
}
